webpackJsonp([283],{

/***/ 188:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ([{
    props: [{
        name: '<code>type</code>',
        description: 'Type (color) of the icon, optional',
        type: 'String, Object',
        values: '<code>is-white</code>, <code>is-black</code>, <code>is-light</code>,\n                    <code>is-dark</code>, <code>is-primary</code>, <code>is-info</code>, <code>is-success</code>,\n                    <code>is-warning</code>, <code>is-danger</code>,\n                    and any other colors you\'ve set in the <code>$colors</code> list on Sass',
        default: '—'
    }, {
        name: '<code>pack</code>',
        description: 'Icon pack to use',
        type: 'String',
        values: '<code>mdi</code>, <code>fa</code>, <code>fas</code>, <code>far</code>, <code>fad</code>, <code>fal</code>',
        default: '<code>mdi</code>'
    }, {
        name: '<code>icon</code>',
        description: 'Icon name',
        type: 'String',
        values: '—',
        default: '—'
    }, {
        name: '<code>size</code>',
        description: 'Icon size, optional',
        type: 'String',
        values: '<code>is-small</code>, <code>is-medium</code>, <code>is-large</code>',
        default: '—'
    }, {
        name: '<code>custom-size</code>',
        description: 'Overrides icon font size, optional',
        type: 'String',
        values: 'Depends on library: <code>null</code> (smallest), <code>fa-lg</code>, <code>fa-2x</code>, <code>fa-3x</code>,\n                <code>fa-4x</code>, <code>fa-5x</code>,\n                    <code>mdi-18px</code>, <code>mdi-24px</code>, <code>mdi-36px</code>, <code>mdi-48px</code>',
        default: 'Depends on <code>size</code> prop'
    }, {
        name: '<code>custom-class</code>',
        description: 'Add class to icon font (<code>&lt;i&gt;</code> tag), optional.\n                    See <a href="https://materialdesignicons.com/getting-started" target="_blank">here for MDI</a>,\n                    <a href="http://fontawesome.io/examples/" target="_blank">here for FontAwesome 4</a> and\n                    <a href="https://fontawesome.com/how-to-use/on-the-web/using-with/vuejs" target="_blank">here for FontAwesome 5</a> custom classes',
        type: 'String',
        values: '—',
        default: '—'
    }]
}]);

/***/ })

});


// WEBPACK FOOTER //
// static/js/283.668a107af9c27e8d5d70.js